import { render, staticRenderFns } from "./index.vue?vue&type=template&id=78fce770&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fce770",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78fce770')) {
      api.createRecord('78fce770', component.options)
    } else {
      api.reload('78fce770', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=78fce770&scoped=true&", function () {
      api.rerender('78fce770', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/hotword-search/modules/table-list/index.vue"
export default component.exports